import { 
    Component,
    ViewChild,
    ElementRef,
    OnInit
}                                   from "@angular/core";

import {
    MESSAGE_GLOBAL_KEY,
    MESSAGE_DIALOG_TYPE,
    MESSAGE_DIALOG_RETURN_TYPE
}                                   from "../../common.constant";
import { GlobalState }              from "../../services";
import { Md2Dialog }                from "../dialog/dialog";

@Component({
    selector: "ctm-message",
    template: require('./message.html')
})
export class CtmMessage {
    @ViewChild("messageDlg") messageDlg: Md2Dialog;
    @ViewChild("btnOK") btnOK: ElementRef;
    @ViewChild("btnClose") btnClose: ElementRef;
    @ViewChild("btnYes") btnYes: ElementRef;
    @ViewChild("btnNo") btnNo: ElementRef;
    @ViewChild("btnCancel") btnCancel: ElementRef;

    private message: string;
    private returnToCaller: Function;
    private messageType: MESSAGE_DIALOG_TYPE;
    private returnType: MESSAGE_DIALOG_RETURN_TYPE;

    private buttonOKCaption: string;
    private buttonCloseCaption: string;
    private buttonYesCaption: string;
    private buttonNoCaption: string;
    private buttonCancelCaption: string;
    
    constructor(
        private global: GlobalState
    ) {
        this.messageType = MESSAGE_DIALOG_TYPE.INFORMATION;
        this.returnType = MESSAGE_DIALOG_RETURN_TYPE.OK;

        this.global.subscribe(MESSAGE_GLOBAL_KEY, (data) => {
            this.message = data.message;
            this.messageType = data.type;

            this.buttonNoCaption = null;
            if (data.option != undefined) {
                if (data.option.buttonOKCaption != undefined) {
                    this.buttonOKCaption = data.option.buttonOKCaption;
                }
                if (data.option.buttonCloseCaption != undefined) {
                    this.buttonCloseCaption = data.option.buttonCloseCaption;
                }
                if (data.option.buttonYesCaption != undefined) {
                    this.buttonYesCaption = data.option.buttonYesCaption;
                }
                if (data.option.buttonNoCaption != undefined) {
                    this.buttonNoCaption = data.option.buttonNoCaption;
                }
                if (data.option.buttonCancelCaption != undefined) {
                    this.buttonCancelCaption = data.option.buttonCancelCaption;
                }
            }
            
            if (this.messageType == MESSAGE_DIALOG_TYPE.INFORMATION
                || this.messageType == MESSAGE_DIALOG_TYPE.WARNING) {
                this.returnType = MESSAGE_DIALOG_RETURN_TYPE.OK;
            }
            else if (this.messageType == MESSAGE_DIALOG_TYPE.ERROR) {
                this.returnType = MESSAGE_DIALOG_RETURN_TYPE.CLOSE;
            }
            else if (this.messageType == MESSAGE_DIALOG_TYPE.QUESTION) {
                this.returnType = MESSAGE_DIALOG_RETURN_TYPE.NO;
            }
            else if (this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL) {
                this.returnType = MESSAGE_DIALOG_RETURN_TYPE.CANCEL;
            }
            else if (this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_OK) {
                this.returnType = MESSAGE_DIALOG_RETURN_TYPE.CANCEL;
            }

            this.returnToCaller = data.caller;
            this.messageDlg.open()
                .then(() => {
                    setTimeout(() => {
                        if (this.messageType == MESSAGE_DIALOG_TYPE.INFORMATION
                            || this.messageType == MESSAGE_DIALOG_TYPE.WARNING) {
                            this.btnOK.nativeElement.focus();
                        }
                        else if (this.messageType == MESSAGE_DIALOG_TYPE.ERROR) {
                            this.btnClose.nativeElement.focus();
                        }
                        else if (this.messageType == MESSAGE_DIALOG_TYPE.QUESTION) {
                            this.btnNo.nativeElement.focus();
                        }
                        else if (this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL) {
                            this.btnCancel.nativeElement.focus();
                        }
                        else if (this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_OK) {
                            this.btnCancel.nativeElement.focus();
                        }
                    }, 0);                    
                });
        });
    }

    private onOKClick() {
        this.returnType = MESSAGE_DIALOG_RETURN_TYPE.OK;
        this.messageDlg.close();
    }
    private onCloseClick() {
        this.returnType = MESSAGE_DIALOG_RETURN_TYPE.CLOSE;
        this.messageDlg.close();
    }
    private onYesClick() {
        this.returnType = MESSAGE_DIALOG_RETURN_TYPE.YES;
        this.messageDlg.close();
    }
    private onNoClick() {
        this.returnType = MESSAGE_DIALOG_RETURN_TYPE.NO;
        this.messageDlg.close();
    }
    private onCancelClick() {
        this.returnType = MESSAGE_DIALOG_RETURN_TYPE.CANCEL;
        this.messageDlg.close();
    }

    private get showInfoIcon() {
        return this.messageType == MESSAGE_DIALOG_TYPE.INFORMATION;
    }
    private get showWarningIcon() {
        return this.messageType == MESSAGE_DIALOG_TYPE.WARNING
        || this.messageType == MESSAGE_DIALOG_TYPE.WARNING_QUESTION;
    }
    private get showErrorIcon() {
        return this.messageType == MESSAGE_DIALOG_TYPE.ERROR;
    }
    private get showQuestionIcon() {
        return this.messageType == MESSAGE_DIALOG_TYPE.QUESTION
            || this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL
            || this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_OK;
    }

    private get showOKButton() {
        return this.messageType == MESSAGE_DIALOG_TYPE.INFORMATION
            || this.messageType == MESSAGE_DIALOG_TYPE.WARNING
            || this.messageType == MESSAGE_DIALOG_TYPE.WARNING_QUESTION
            || this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_OK;
    }
    private get showCloseButton() {
        return this.messageType == MESSAGE_DIALOG_TYPE.ERROR;
    }
    private get showYesButton() {
        return this.messageType == MESSAGE_DIALOG_TYPE.QUESTION
            || this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL;
    }
    private get showNoButton() {
        return this.messageType == MESSAGE_DIALOG_TYPE.QUESTION
            || this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL;
    }
    private get showCancelButton() {
        return this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_WITH_CANCEL
        || this.messageType == MESSAGE_DIALOG_TYPE.WARNING_QUESTION
        || this.messageType == MESSAGE_DIALOG_TYPE.QUESTION_OK;
    }

    private onMessageClose() {
        if (typeof (this.returnToCaller) == "function") {
            this.returnToCaller(this.returnType);
        }
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/components/message/message.ts